import type { UiLogoVariant } from './UiLogo.types';

export const LOGO_MAP: Record<UiLogoVariant, string> = {
    emblem: '/logos/logo-emblem.svg',
    wordmark: '/logos/logo-wordmark.svg',
    full: '/logos/logo-full.svg',
    footer: '/logos/logo-footer.svg',
};
